import React from 'react'

const SearchIcon = ({size = 22}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingRight: '6px',
    }}
  >
    <div
      style={{
        height: `${size}px`,
        width: `${size}px`,
      }}
    >
      <svg
        viewBox="0 0 192.6 225.8"
      >
        <path fill="#9AA0A6" d="M191.1,206.1l-40.6-55.4c-2.1-2.9-1.9-6.7,0.4-9.4c25.1-29.5,27.8-73.5,3.9-106.2C138.8,13.1,112.9,0,85.6,0
            C67.4,0,49.9,5.7,35.1,16.5C-3.1,44.4-11.4,98.2,16.5,136.3c16.1,22,42,35.1,69.3,35.1c11.5,0,22.7-2.3,33.1-6.7
            c3.3-1.4,7-0.4,9.1,2.5l40.5,55.4c2.5,3.4,7.2,4.1,10.6,1.6l10.4-7.6C192.8,214.3,193.6,209.5,191.1,206.1z M27.8,128.1
            C4.4,96.2,11.4,51.2,43.3,27.8C55.7,18.8,70.3,14,85.6,14c22.8,0,44.5,11,58,29.4c23.4,31.9,16.4,76.9-15.5,100.2
            c-12.4,9.1-27,13.8-42.3,13.8C62.9,157.5,41.3,146.5,27.8,128.1z"
        />
      </svg>
    </div>
  </div>
)

export default SearchIcon
